import { SingleOperation } from "../operations/Operation";
import { Verb } from "../types/Verb";
import { AttributeKey } from "../types/attributes";
import { WBEventUpsertSubjectAttributeSinglePayload } from "../types/WBEvent2";

export class SetAttributeOperation extends SingleOperation {
  subjects: string[];
  key: AttributeKey;

  constructor(
    subjects: string[],
    key: AttributeKey,
    oldValue: unknown,
    value: unknown
  ) {
    const backwardEvents: WBEventUpsertSubjectAttributeSinglePayload[] =
      subjects.map((subjectID) => {
        return {
          verb: Verb.UpsertSubjectAttributeSingle,
          subjectID,
          version: -1,
          attribute: { key, value: oldValue },
        };
      });

    const forwardEvents: WBEventUpsertSubjectAttributeSinglePayload[] =
      subjects.map((subjectID) => {
        return {
          verb: Verb.UpsertSubjectAttributeSingle,
          subjectID,
          version: -1,
          attribute: { key, value },
        };
      });

    super(forwardEvents, backwardEvents);
    this.subjects = subjects;
    this.key = key;
  }

  get label(): string {
    if (this.subjects.length == 1) {
      return `Update ${this.key} on ${this.subjects.length} shapes`;
    } else {
      return `Update ${this.key} on 1 shape`;
    }
  }
}
